import * as React from 'react';
import { SVGProps } from 'react';

const HomeTransactionIcon = ({ width = '21', height = '20', fill = '#615A5A' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7808_198398)">
      <path
        d="M38.1034 19.9987V23.5365H33.3865V37.6874H26.311V23.5365H14.5185V37.6874H7.44306V23.5365H2.72607V19.9987L20.4148 2.31006L26.311 8.20628V2.31006H33.3865V15.2818L38.1034 19.9987Z"
        stroke="#C8C6C6"
        strokeWidth={3.83}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7808_198398">
        <rect width={40} height={40} fill="white" transform="translate(0.41626)" />
      </clipPath>
    </defs>
  </svg>
);
export default HomeTransactionIcon;
